import styles from "./styles.module.css";

const BasicSelect = ({ options, label, ...rest }) => {
  return (
    <div className={styles.container__basicSelect}>
      <select
        className={styles.select__basicSelect}
        style={rest.style}
        {...rest}
      >
        <option style={{ display: "none" }} value="">
          {label}
        </option>
        {options.length > 0
          ? options.map((item) => <option value={`${item}`}>{item}</option>)
          : ""}
      </select>
    </div>
  );
};

export default BasicSelect;
